import * as clientParentDetailsActions from '@client-parents/actions/client-parent-details.actions';
import { ClientParentDetails } from '@client-parents/models/client-parent-details';

export interface State {
  clientParentDetails: ClientParentDetails,
  loading: boolean,
}

export const INITIAL_STATE: State = {
  clientParentDetails: undefined,
  loading: false,
}

export function reducer(state: State = INITIAL_STATE, action: clientParentDetailsActions.Actions): State {
  switch (action.type) {
    case clientParentDetailsActions.GET:
      {
        return { ...state, clientParentDetails: undefined, loading: true };
      }
    case clientParentDetailsActions.GET_COMPLETE:
      {
        return { ...state, clientParentDetails: action.payload, loading: false };
      }
    default:
      {
        return state;
      }
  }
}
